import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { CustomizationForm } from '../CustomizationForm';
import { CustomStylesProvider } from '../providers/StylesProvider';
import { Auth } from 'modules/auth';

function App() {
  return (
    <CustomStylesProvider>
      <Routes>
        <Route path="/" element={<CustomizationForm />} />
        <Route path="/auth" element={<Auth />} />
      </Routes>
      <ToastContainer limit={1} />
    </CustomStylesProvider>
  );
}

export default App;
